import { useContext, useEffect, useRef } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import AuthContext from '../contexts/AuthContext';
import ContentById from '../graphql/queries/contentbyId';
import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router';

import progressbyId from '../graphql/queries/progressbyId';
import CreateProgressMutation from '../graphql/mutations/createProgress';
import CloudflareVideoPlayer from '../components/pages/videoPlayerPage/clondflareVideoPlayer';

const VideoPlayerPage = () => {
  const { user } = useContext(AuthContext);
  const creatingProgressRef = useRef(false);

  const param = useParams();

  const { data: Content } = useQuery(ContentById, {
    variables: {
      _id: param?.contentId,
    },
  });

  const { data: userprogress, loading: progressLoading, refetch: refetchProgress } = useQuery(progressbyId, {
    variables: {
      content: param?.contentId,
      student: user?._id,
    },
    skip: !user?._id,
  });
  const [createProgress] = useMutation(CreateProgressMutation);

  const progressId = userprogress?.progress?._id || null;
  const initialWatchedRanges = userprogress?.progress?.watchedRanges || [];
  const lastWatched = userprogress?.progress?.lastWatched || 0;
  const videoLength = Content?.content?.duration || 0;
  const videoUrl = Content?.content?.link || '';

  useEffect(() => {
    if (!user?._id || !Content?.content?._id || progressLoading || progressId || creatingProgressRef.current) return;

    creatingProgressRef.current = true;
    createProgress({
      variables: {
        content: Content.content._id,
        student: user._id,
        progress: 0,
        path: window.location.href,
      },
    })
      .catch((error) => {
        if (!error?.message?.includes('progress already have')) {
          console.error('Create video progress error:', error);
        }
      })
      .finally(() => {
        refetchProgress({ content: Content.content._id, student: user._id })
          .catch((error) => console.error('Refetch video progress error:', error))
          .finally(() => {
            creatingProgressRef.current = false;
          });
      });
  }, [Content, createProgress, progressId, progressLoading, refetchProgress, user]);

  return (
    <Box w={'100%'} mt={10}>
      <Box px={[2, 2, 10, 20]}>
        <CloudflareVideoPlayer
          videoUrl={videoUrl}
          videoLength={videoLength}
          progressId={progressId}
          initialWatchedRanges={initialWatchedRanges}
          lastWatched={lastWatched}
        />{' '}
        <Heading py={'4'}>{Content?.content?.name}</Heading>
        <Text p={'2'}>{Content?.content?.carddescription}</Text>
      </Box>

      {/* <Text>
                {progressState?.activetime}{`TRACK ${tracking % 10} `}
            </Text> */}
    </Box>
  );
};

export default VideoPlayerPage;
